module.exports = __webpack_public_path__ + "static/media/softball.766a80ae.jpg";